import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import { forword } from "../../actions/studensts";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { useState } from "react";

export default function ActionButtonsNew() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading2, setLoading2] = useState(false);
  const { id } = useParams();

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading2(false);
      // navigate("/main/mohe/new");
    }, 2000);
  }

  const handleForward = async () => {
    setLoading2(true);
    const res = await forword(
      id,
      "mohe/",
      "done",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <div className="pt-4 space-y-3">
      {showSuccessAlert && <AlertSuccess text={text} />}
      {showDengerAlert && <AlertDenger text={text} />}
      <div className="flex flex-wrap gap-3">
        <Button
          color="bg-emerald-600 hover:bg-emerald-500 disabled:bg-white/10 disabled:text-slate-500"
          onClick={handleForward}
          disabled={loading2}
          text={!loading2 ? "Forward To Done" : <Loading />}
        />
      </div>
    </div>
  );
}
